
export default [
  {
    path: "/",
    name: "rede-de-atendimento",
    meta: {
        header: {
            clean: true,
            hide: false,
            logo: "dasa-filoo.png"
        },
       
    },
    component: () =>
        import(
            "@/views/services/results-found-dasa/results-found-dasa.vue"
        ),
  },
  {
    path: '/cadastre-se',
    name: 'sign-up',
    component: () => import('@/views/SignUp/SignUp.vue'),
    beforeEnter (to, from, next) {
      if (to.query.plan_code) {
        sessionStorage.setItem('planCode', to.query.plan_code)
      } else {
        sessionStorage.removeItem('planCode')
      }
      if (to.query.partner) {
        sessionStorage.setItem('partner', to.query.partner)
      } else {
        sessionStorage.removeItem('partner')
      }
      next()
    }
  },
  {
    path: '/carrinho',
    name: 'shopping',
    meta: {
      breadcrumb: [
        {text: "Home", active: false },
        {text: "Planos", active: false },
        {text: "Confirmar", active: true },
      ]
    },
    component: () => import('@/views/ShoppingCart/ShoppingCart.vue'),
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem("customerData")) {
        return next({ name: 'sign-up'})
      }
      return next()
    }
  },
  {
    path: "/cadastre-se/:planCode",
    name: "SignUpParameter",
    component: () => import("@/views/SignUp/SignUp.vue"),
  },
  {
    path: "/signup-simple/",
    name: "SignUpSimple",
    meta: {
      simple: true
    },
    component: () => import("@/views/SignUp/SignUp.vue"),
  },
  {
    path: "/signup-simple/:planCode",
    name: "SignUpSimpleParameter",
    meta: {
      simple: true
    },
    component: () => import("@/views/SignUp/SignUp.vue"),
  },
  {
    path: "/confirmacao-pedido",
    name: "PaymentConfirmation",
    component: () =>
      import("@/views/PaymentConfirmation/PaymentConfirmation.vue"),
  },
  {
    path: "/signup-simple-finalization",
    name: "SignUpSimpleFinalization",
    meta: {
      simple: true
    },
    component: () => import("@/views/PaymentConfirmation/PaymentConfirmation.vue"),
  },
  {
    path: '/error404',
    name: 'error404',
    component: () => import('@/views/errors/error404.vue')
  },
  {
    path: '*',
    redirect: { name: 'error404' }
  },
]
